import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import BackgroundEffects from '@/components/BackgroundEffects';
import WaitlistForm from '@/components/WaitlistForm';

const stagger = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.1 },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] },
  },
};

const WaitlistPage = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-[#050505] overflow-hidden" data-testid="waitlist-page">
      <BackgroundEffects />

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6">
        <motion.div
          variants={stagger}
          initial="hidden"
          animate="show"
          className="flex flex-col items-center text-center max-w-lg"
        >
          {/* Logo */}
          <motion.span
            variants={fadeUp}
            className="text-2xl font-black tracking-tighter text-white mb-12 sm:mb-16"
            style={{ fontFamily: "'Outfit', sans-serif" }}
            data-testid="waitlist-logo"
          >
            Prevy
          </motion.span>

          {/* Coming soon headline */}
          <motion.h1
            variants={fadeUp}
            className="text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05]"
            style={{ fontFamily: "'Outfit', sans-serif" }}
            data-testid="waitlist-headline"
          >
            <span className="text-[#FF4F00]">Pronto,</span>
            <br />
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-white to-white/60">
              Muy Pronto...
            </span>
          </motion.h1>

          {/* Description */}
          <motion.div variants={fadeUp} className="mt-6 max-w-sm text-center">
            <p
              className="text-zinc-500 text-sm sm:text-base font-light"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Prevy está en la fase final de desarrollo.
            </p>
            <p
              className="text-white text-sm sm:text-base font-medium mt-3 leading-relaxed"
              style={{ fontFamily: "'Manrope', sans-serif" }}
              data-testid="waitlist-description"
            >
              Déjanos tu correo y te avisamos en cuanto esté lista.
            </p>
          </motion.div>

          {/* Waitlist form */}
          <div className="mt-10 sm:mt-12 w-full max-w-md">
            <WaitlistForm />
          </div>

          {/* Back link */}
          <motion.button
            variants={fadeUp}
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-zinc-500 hover:text-white text-sm mt-10 transition-colors"
            data-testid="waitlist-back-button"
          >
            <ArrowLeft className="w-4 h-4" /> Volver
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
};

export default WaitlistPage;
